import { cn } from '@/utils/cn';

interface BoxProps {
  children: React.ReactNode;
  isSelected: boolean;
  onSelect: () => void;
}

export const Box = ({ children, isSelected, onSelect }: BoxProps) => {
  return (
    <div
      className={cn(
        'p-2 flex justify-center items-center h-14 border-1 rounded-md border-base-border cursor-pointer min-w-19 w-full',
        isSelected && 'border-selected-border bg-selected-background'
      )}
      onClick={onSelect}
    >
      {children}
    </div>
  );
};
